import { render } from "./CreateOrder.vue?vue&type=template&id=ca2c1f84"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"

import "./CreateOrder.vue?vue&type=style&index=0&id=ca2c1f84&lang=css"
script.render = render

export default script